import { FloatingFormItem } from '@/components/_common';
import {
  useAccountPayableObservationCreate,
  useAccountPayableObservationUpdate,
} from '@/core/domain/financial/AccountPayableObservation/AccountPayableObservation.hooks';
import { AccountPayableObservation } from '@/core/domain/financial/AccountPayableObservation/AccountPayableObservation.types';
import { Form, Input } from 'antd';
import Modal, { ModalProps } from 'antd/lib/modal/Modal';
import React, { useEffect } from 'react';

interface Props extends Omit<ModalProps, 'onCancel'> {
  onCancel: VoidFunction;
  installmentPayableId: number;
  observationData?: AccountPayableObservation;
}

const AccountPayableObservationModal: React.FC<Props> = ({
  installmentPayableId,
  observationData,
  ...props
}) => {
  const [form] = Form.useForm<{ observation: string }>();
  const observationWatch = Form.useWatch('observation', form);

  const { mutateAsync: create, isLoading: createLoading } =
    useAccountPayableObservationCreate();
  const { mutateAsync: update, isLoading: editLoading } =
    useAccountPayableObservationUpdate();

  const handleOk = async () => {
    const { observation } = await form.validateFields();

    if (!!observationData) {
      await update({ id: observationData.id, observation });
    } else if (installmentPayableId) {
      await create({ observation, installmentPayableId });
      form.resetFields();
    }

    props.onCancel();
  };

  useEffect(() => {
    form.setFieldValue('observation', observationData?.observation);
  }, [observationData]);

  return (
    <Modal
      {...props}
      title={`${!!observationData ? 'Editar' : 'Nova'} observação`}
      okText={!!observationData ? 'Salvar' : 'Adicionar'}
      okButtonProps={{
        disabled:
          !observationWatch?.length ||
          (!!observationData &&
            observationWatch === observationData?.observation),
      }}
      confirmLoading={createLoading || editLoading}
      onOk={handleOk}
      width={600}
    >
      <Form form={form}>
        <FloatingFormItem label="Observação" name="observation">
          <Input.TextArea rows={4} />
        </FloatingFormItem>
      </Form>
    </Modal>
  );
};

export default AccountPayableObservationModal;
